import React from 'react';
import { cn } from '../../utils/cn';

interface FullWidthContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const FullWidthContainer: React.FC<FullWidthContainerProps> = ({ children, className }) => {
  return (
    <div className={cn('w-full max-w-none px-4 sm:px-6 lg:px-8 py-6 relative', className)}>
      {children}
    </div>
  );
};
